import gladIcon from "@assets/gladIcon.png"
import Button from "@components/Button"
import Layout from "@components/Layout"
import { Trans, useTranslation } from "react-i18next"
import { Form } from "react-router-dom"

export default function GladPage() {
  const { t } = useTranslation()

  return (
    <Layout>
      <div className="flex grow flex-col items-center justify-center gap-5 text-center">
        <img
          alt="Glad icon"
          className="h-auto w-40 rounded-lg"
          src={gladIcon}
        />

        <h1 className="custom-heading">{t("pages.onboarding.glad.heading")}</h1>

        <p className="text-xl">
          <Trans
            components={{
              colored: <span className="custom-text-colored font-bold" />,
            }}
            i18nKey="pages.onboarding.glad.text"
          />
        </p>
      </div>

      <Form className="shrink-0" method="post">
        <input
          name={t("pages.onboarding.glad.heading", { lng: "en" })}
          type="hidden"
          value={t("shared.continue", { lng: "en" })}
        />

        <Button title={t("shared.continue")} type="submit" />
      </Form>
    </Layout>
  )
}
